import { render, staticRenderFns } from "./highchart-new.vue?vue&type=template&id=2ba03f9c"
import script from "./highchart-new.vue?vue&type=script&lang=ts"
export * from "./highchart-new.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports